




























































































































































































































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import Accordion from "../shared/Accordion.vue";
import {
  AuthService,
  deleteToken,
  retrieveToken,
  storeToken
} from "../../services/AuthService";
import { CustomerService } from "../../services/CustomerService";
import vSelect from "vue-select";
import store from "../../vuex/store";
import { required, sameAs } from "vuelidate/lib/validators";
import { passwordRegex } from "../../definitions/password-validator";
import ClickOutside from "vue-click-outside";
import QaplaButton from "@/components/shared/QaplaButton.vue";
import { _keycloak } from "@/bootstrap";
import { LegalEntity } from "@/model/component.model";
import { JwtHelper } from "@/utils/JwtHelper";

class UserStore {
  value: number;
  label: string;
  idEntity: number;
  entityType: string;
}
@Component({
  validations: {
    currentPassword: {
      required
    },
    newPassword: {
      required,
      password: passwordRegex
    },
    repeatPassword: {
      required,
      sameAs: sameAs("newPassword")
    }
  },
  components: {
    MbeAccordion: Accordion,
    QaplaButton: QaplaButton,
    vSelect: vSelect
  },
  directives: {
    ClickOutside
  }
})
export default class UserSidebar extends Vue {
  @Prop({})
  isOpen: boolean;
  permitChangeStore: boolean;
  auth: AuthService;
  customerService: CustomerService;
  userStores: UserStore[] = [];
  selectedStore: UserStore;
  urlAccountConsole = store.getters.KEYCLOAK_BASE_API_URL + "/account";
  legalEntity: LegalEntity;
  impersonation = false;
  currentPassword = "";
  newPassword = "";
  repeatPassword = "";
  showPrintOnline = false;
  printOnlineUrl = "";

  constructor() {
    super();
    this.auth = new AuthService();
    this.customerService = new CustomerService();
  }

  closeSidebar() {
    this.$emit("userSidebarIsOpened", false);
  }

  logout() {
    setTimeout(() => {
      this.auth.revoke().then(
        () => {
          deleteToken();
          this.$emit("userSidebarIsOpened", false);
          // this.$router.push({ name: "Login" });
          // location.reload();
        },
        err => {
          this.$router.push({ name: "Login" });
          location.reload();
        }
      );
    }, 500);
  }

  async logback() {
    const tokenJwt = retrieveToken();
    const tokenDecoded = JwtHelper.decodeToken(tokenJwt.access_token);
    const impersonationChain = tokenDecoded["impersonation_chain"];
    const lastImpersonation = impersonationChain[impersonationChain.length - 1];
    const impersonatorId = lastImpersonation.legalEntityId;
    const impersonatorType = lastImpersonation.legalEntityType;
    await this.auth
      .onBehalfLogin(this.$store.getters["impersonator"])
      .then((res: any) => {
        storeToken(res.data);
        let legalEntityFiltered = {} as any;
        this.auth.getLegalEntities().then(res => {
          legalEntityFiltered = res.data.filter(
            item =>
              item.idEntity === impersonatorId &&
              item.entityType == impersonatorType
          );
          if (legalEntityFiltered.length > 0) {
            this.legalEntity = {
              idEntity: legalEntityFiltered[0].idEntity,
              entityType: legalEntityFiltered[0].entityType,
              description: legalEntityFiltered[0].description,
              active: legalEntityFiltered[0].active,
              parentId: legalEntityFiltered[0].parentId,
              id: legalEntityFiltered[0].id
            };
          } else {
            this.legalEntity = {
              idEntity: res.data[0].idEntity,
              entityType: res.data[0].entityType,
              description: res.data[0].description,
              active: res.data[0].active,
              parentId: res.data[0].parentId,
              id: res.data[0].id
            };
          }
          this.fetchHub(this.legalEntity);
        });
      });
  }

  async fetchHub(selectedStore: any) {
    try {
      const finalHubToken = await this.auth.selectStoreHub({
        idEntity: selectedStore.idEntity,
        entityType: selectedStore.entityType,
        description: selectedStore.description,
        id: selectedStore.id
      });
      deleteToken();
      window.location.replace(
        this.$store.getters["BASE_HUB_URL"] +
          `/login?token=${(finalHubToken as any).access}&refresh=${
            (finalHubToken as any).refresh
          }`
      );
    } catch (error) {
      window.console.error(error);
    }
  }

  created() {
    if (
      this.$store.getters["customer/config"].printOnlineUrl &&
      this.$store.getters["customer/config"].printOnlineUrl !== ""
    ) {
      this.printOnlineUrl = this.$store.getters[
        "customer/config"
      ].printOnlineUrl;
    } else {
      this.printOnlineUrl = this.$store.getters.features.printOnlineStoreUrl;
    }

    this.showPrintOnline =
      this.$store.getters.features.printOnlineEnabled &&
      this.printOnlineUrl &&
      this.printOnlineUrl !== "";
    const tokenObject = JSON.parse(localStorage.getItem("mol-token"));
    if (tokenObject["impersonator"]) {
      this.$store.commit("setImpersonator", tokenObject["impersonator"]);
      this.impersonation = true;
    }
    const firstImpersonator:
      | string
      | null = JwtHelper.getTokenFirstImpersonator(tokenObject);
    this.$store.commit("setFirstImpersonator", firstImpersonator);
    this.permitChangeStore = false;
    this.getUserStores();
  }

  get impersonator() {
    return this.$store.getters.impersonator;
  }

  get firstImpersonator() {
    return this.$store.getters.firstImpersonator;
  }
  openPrintOnline() {
    window.open(this.printOnlineUrl, "_BLANK");
  }

  // Function to change language
  changeLanguage(lang: any) {
    //We execute this code only if the language is actually being changed
    if (this.$store.getters.language != lang) {
      this.$i18n.i18next.changeLanguage(lang);
      this.$store.commit("updateLanguage", lang);

      CustomerService.loadCustomerConfig(store).then(value => {
        const customerOnlineMBEConfiguration = this.$store.getters[
          "customer/config"
        ];
        customerOnlineMBEConfiguration.language = lang;
        this.$store.commit(
          "customer/setCustomerConfig",
          customerOnlineMBEConfiguration
        );
        CustomerService.saveCustomerConfig(
          this.$store.getters["customer/info"].customerId,
          customerOnlineMBEConfiguration
        );

        //refresh
        location.reload();
      });
    }
  }

  /* Operation about the stores */
  getUserStores() {
    for (let i = 0; i < this.$store.getters.userStores.length; i++) {
      const valueStore = {
        value: this.$store.getters.userStores[i].id,
        idEntity: this.$store.getters.userStores[i].idEntity,
        label: this.$store.getters.userStores[i].description,
        entityType: this.$store.getters.userStores[i].entityType
      } as UserStore;
      this.userStores.push(valueStore);
    }
    this.getStoreSelected();
  }
  getStoreSelected() {
    this.selectedStore = {
      value: this.$store.getters.storeSelected.id,
      idEntity: this.$store.getters.storeSelected.idEntity,
      label: this.$store.getters.storeSelected.description,
      entityType: this.$store.getters.storeSelected.entityType
    } as UserStore;
  }
  //changeStore($event: UserStore) {
  //	// To skip the first call when I open the user sidebar
  //	if (this.permitChangeStore && $event !== null) {
  //		const store = {
  //			idEntity: $event.idEntity,
  //			description: $event.label,
  //			id: $event.value,
  //			entityType: $event.entityType
  //		} as LegalEntity;

  //		return this.auth.selectStore(store, this.$t('no_department').toString()).then((res: any) => {
  //			this.$router.push({ name: 'Dashboard' });
  //			return res;
  //		}).catch(err => {
  //			return Promise.reject(err.message);
  //		});
  //	}
  //	this.permitChangeStore = true;
  //	return;
  //}

  close() {}
  changePassword(currentPassword: string, newPassword: string) {
    this.auth
      .changePassword(store.getters.user.username, currentPassword, newPassword)
      .then(res => {
        this.$alerts.success(this.$t("password_changed"));
      })
      .catch(err => {
        this.$alerts.danger(err.data.message);
      });
  }

  get firstname() {
    return this.$store.getters.user.firstname;
  }
  get lastname() {
    return this.$store.getters.user.lastname;
  }

  get showQaplaButton() {
    return (
      this.$store.getters.features.qapla.qaplaEnabled &&
      this.$store.getters.features.qapla.customerQaplaEnabled &&
      this.$store.getters.features.qapla.storeQaplaEnabled
    );
  }

  get customerFirstAddress() {
    if (this.$store.getters["customer/info"] !== undefined) {
      if (this.$store.getters["customer/info"].address !== undefined) {
        if (
          this.$store.getters["customer/info"].address.addresses !==
            undefined &&
          this.$store.getters["customer/info"].address.addresses.length > 0
        ) {
          return this.$store.getters["customer/info"].address.addresses[0];
        }
      }
    }

    return "";
  }
}
